import {
  Button,
  Chip,
  Dialog,
  Grid,
  Menu,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { Dispatch, SetStateAction, useContext, useState } from "react";
import { BentoBrand, UpgradeDialogSource } from "schemas/dashboard";

import { trackEvent } from "utils/tracking";

interface Props {
  anchorEl: null | HTMLElement;
  setAnchorEl: Dispatch<SetStateAction<null | HTMLElement>>;
  selectedBrand: BentoBrand;
}

const ExclusiveBrand = ({ anchorEl, setAnchorEl, selectedBrand }: Props) => {
  const { setUpgradeDialogSource, subscription } =
    useContext(SubscriptionContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [openDialog, setOpenDialog] = useState(false);

  const open = Boolean(anchorEl);
  const id = open ? "exclusive-brand" : undefined;

  const renderMenuContent = () => {
    return (
      <>
        <Grid
          container
          justifyContent={"center"}
          direction={"column"}
          sx={{
            px: 3,
            py: 2,
            maxWidth: 300,
          }}
        >
          <Grid container justifyContent={"center"} item xs={12} sx={{ mb: 1 }}>
            <Chip
              size="small"
              sx={{
                backgroundColor: "yellow.main",
                width: "max-content",
                fontWeight: 600,
                px: 1,
              }}
              label="Reach exclusive brands"
            />
          </Grid>

          {!subscription?.isSubscribed ? (
            <>
              <Typography textAlign={"center"}>
                Unlock access to 300K+ brands that other creators can't pitch.
                Available exclusively to Bento subscribers.
              </Typography>
              <Button
                sx={{ mt: 1 }}
                fullWidth
                disableElevation
                variant="contained"
                onClick={() => {
                  setUpgradeDialogSource(UpgradeDialogSource.exclusive_brand);
                  trackEvent("Shown Paywall Dialog", {
                    "Brand Tier": selectedBrand?.tier,
                    "Contacted Recently Amount":
                      selectedBrand?.contactedRecentlyAmount,
                    Reason: "Exclusive Brand",
                  });
                }}
              >
                Upgrade to Email
              </Button>
            </>
          ) : (
            <Typography textAlign={"center"}>
              As a subscriber, you have access to 300K+ brands that other
              creators can't pitch.
            </Typography>
          )}
        </Grid>
      </>
    );
  };

  return (
    <>
      <Button
        onClick={(e) => {
          if (isMobileScreen) {
            setOpenDialog(true);
          } else {
            setAnchorEl(e.currentTarget);
            setOpenDialog(false);
          }
        }}
        variant="outlined"
        size="small"
        sx={{
          textTransform: "none",
          fontSize: 12,
          borderRadius: "24px",
          color: "info.main",
        }}
      >
        Exclusive 💎
      </Button>
      <Menu
        id={id}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        sx={{ zIndex: 1200 }}
        onClose={() => setAnchorEl(null)}
      >
        {renderMenuContent()}
      </Menu>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        {renderMenuContent()}
      </Dialog>
    </>
  );
};

export default ExclusiveBrand;
